import { Injectable } from '@angular/core';
import { ErrorResponse } from 'src/app/models/error-response';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  private _error: ErrorResponse = {
    title: '',
    status: 0,
    detail: '',
  };

  get error() {return  this._error;}
  set error(value: ErrorResponse) {
    this._error = {...(value ?? this._error)};
  } 


  constructor() { }
}
